import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { selectAsianGamesGames, selectGamesLoading } from '@/store/games/selectors';
import GamesStreamlineSection, {
  GamesStreamlineType,
} from '@/components/shared/games/GamesStreamlineSection';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesSectionHeader from '@/pages/games/lobby/lobby-sections-streamlines/GamesSectionHeader';
import GamesSection from '@/pages/games/lobby/lobby-sections-streamlines/GamesSection';

const AsianGames = () => {
  const games = useSelector(selectAsianGamesGames);
  const loading = useSelector(selectGamesLoading);
  const intl = useIntl();

  if (games.length === 0 && !loading) return null;

  return (
    <GamesSection>
      <GamesSectionHeader
        title={intl.formatMessage({ id: 'games.categories.asian-games' })}
        totalGames={games.length}
        categoryPath="/games/asian-games"
      />
      <GamesStreamlineSection
        type={GamesStreamlineType.Single}
        visibleGames={18}
        loading={loading}
        games={games}
        category={BffGamesCategory.AsianGames}
      />
    </GamesSection>
  );
};

export default AsianGames;
